import ApiService from '../../services/apiService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreFederatedLogin',
  data() {
    return {
      clients: [],
      rememberUser: false
    };
  },
  watch: {
    rememberUser() {
      if (this.rememberUser) {
        this.clients = this.clients.map(client => {
          client.redirectURI = client.redirectURI.replace('access_type=online', 'access_type=offline');
          return client;
        });
        this.clients = cloneDeep(this.clients);
        return;
      }
      this.clients = this.clients.map(client => {
        client.redirectURI = client.redirectURI.replace('access_type=offline', 'access_type=online');
        return client;
      });
      this.clients = cloneDeep(this.clients);
    }
  },
  mounted() {
    this.loadClients();
  },
  methods: {
    async loadClients() {
      const oauthClients = await ApiService.getOAuthClientsForURI(window.location.hostname, window.location.origin, this.$route.query.oauthClient);
      const oidcClients = await ApiService.getOIDCClientsForURI(window.location.host, window.location.origin, this.$route.query.oidcClient);
      this.clients = [...(oauthClients || []), ...(oidcClients || [])];
    }
  }
};